@if (error()) {
  <app-error-page
    [error]="error()"
    (clickBack)="router.navigate(['/organizations'])"
    class="block"
    style="height: calc(100vh - 30rem)"
  />
} @else {
  <div class="@container w-full block">
    <ul class="grid grid-cols-1 @2xl:grid-cols-2 @5xl:grid-cols-3 auto-rows-fr gap-5">
      @for (page of supplierContracts(); track page.page; let i = $index) {
        @if (page.isLoading) {
          @if (i === 0) {
            <li class="min-h-98 block"><app-supplier-contract-card-skeleton /></li>
          } @else {
            @for (p of placeholders(); track $index) {
              <li class="min-h-98 block">
                <app-supplier-contract-card-skeleton />
              </li>
            }
          }
        } @else {
          @for (contract of page.contracts; track contract.id) {
            <li class="h-auto block">
              <app-supplier-contract-card
                [fullPrice]="fullPrice()"
                [currentYear]="currentYear()"
                [supplierContract]="contract"
                class="block w-full h-full"
              />
            </li>
          }
        }
      } @empty {
        <li class="min-h-98 block"><app-supplier-contract-card-skeleton /></li>
      }
      @if (showLoadMorePlaceholders()) {
        @for (p of placeholders(); track $index) {
          <li class="min-h-98 block">
            <app-supplier-contract-card-skeleton appInViewport />
          </li>
        }
      }
      <ng-content />
    </ul>
  </div>
}
